import BaseClient from './BaseClient';

class TeamsClient extends BaseClient {
    getShiftToTextMessage(teamId) {
        const url = `/api/v3/teams/${teamId}/shift-to-text/message`;
        return this.makeCoreApiRequest(url);
    }

    updateShiftToTextMessage(teamId, message) {
        const url = `/api/v3/teams/${teamId}/shift-to-text/message`;
        return this.makeCoreApiRequest(url, 'post', {
            message_content: message,
        });
    }

    getShiftToTextRedirect(teamId) {
        const url = `/api/v3/teams/${teamId}/shift-to-text/redirect`;
        return this.makeCoreApiRequest(url);
    }

    updateShiftToTextRedirect(teamId, redirect) {
        const url = `/api/v3/teams/${teamId}/shift-to-text/redirect`;
        return this.makeCoreApiRequest(url, 'post', { redirect });
    }

    adjustMessageBalance(teamId, data) {
        const url = `/settings/teams/${teamId}/adjust-message-balance`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    updateDetails(teamId, data) {
        return this.makeCoreApiRequest(`/settings/teams/${teamId}/name`, 'put', data);
    }

    fetchUpcomingInvoice(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/upcoming-invoice`);
    }

    getHubspotConnectionStatus(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/hubspot/connection-status`);
    }

    disconnectHubspot(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/hubspot`, 'delete');
    }

    getCalendlyConnectionStatus(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/calendly/connection-status`);
    }

    disconnectCalendly(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/calendly`, 'delete');
    }

    getFtpPullStatus(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/ftp-pull/status`);
    }

    getFtpPullConfig(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/ftp-pull`);
    }

    saveFtpPullConfig(teamId, config) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/ftp-pull`, 'post', config);
    }

    deleteFtpPullConfig(teamId, type) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/ftp-pull/${type}`, 'delete');
    }

    getFtpPullRuns(teamId, params) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/ftp-pull/runs`, 'get', null, params);
    }

    getAcuityConnectionStatus(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/acuity/connection-status`);
    }

    disconnectAcuity(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/acuity`, 'delete');
    }

    getRevelStatus(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/revel/status`);
    }

    generateRevelWebhookUrl(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/revel/webhook-url`, 'post');
    }

    disconnectRevel(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/revel`, 'delete');
    }

    getCostVisibility(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/cost-visibility`);
    }

    updateCostVisibility(teamId, data) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/cost-visibility`, 'put', data);
    }
}

export default new TeamsClient();
